import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Input,
  EventEmitter,
  Output,
  OnChanges, SimpleChanges, SimpleChange,
} from '@angular/core';
import {WebSocketService} from '../websockets/websocket.service';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as moment from 'moment';
import {Chart} from '../charts/Chart';
import {SlideChart} from '../charts/charts/slide-chart/SlideChart';
import {OscilloChart} from '../charts/charts/oscillo-chart/OscilloChart';
import {FixedDisplayPeriodScale, FixedScale, RatioScale} from '../charts/Scale';
import * as $ from 'jquery';
import {ChartOffsetCalculatorService} from './chart-utility/chart-offset-calculator.service';
import {SensorDataConverter} from '../services/sensordataconverter.service';
import {TimeSeries} from '../charts/Series';
import 'moment-timezone';
import {SensordataComponent} from '../sensordata/sensordata.component';
import {animate, EasingFunctions} from '../charts/animation/Animation';
import { UserPreferenceService } from '../services/user.preferences.service';
import {EcareSecurityService} from '../services/ecare_security_service';
import {ToastrService} from 'ngx-toastr';
import {SensorChart} from '../charts/charts/sensor-chart/SensorChart';
import { SensorDataService } from '../services/sensordata.service';
import {FormBuilder, FormControl} from '@angular/forms';
/**
 * This class implements graph library and generates graphs specific to datastream provided.
 * @arnab.chakraborty@pathcom.com
 */
@Component({
  selector: 'app-history-data-graph',
  templateUrl: './history-data-graph.component.html',
  styleUrls: ['./history-data-graph.component.css']
})
export class HistoryDataGraphComponent implements OnInit, AfterViewInit, OnChanges  {
  /* Parameters passed through directive. */
  @Input() dataStream: any;
  @Input() settings: any;
  @Input() uiUOM: any;
  @Input() offsetChangedEvent: any;
  @Input() divCounter: any;
  @Input() uiConfiguration: any;
  @Input() start: any;
  graphsLoaded: EventEmitter<any> = new EventEmitter();
  chartAmplitudeValueChanged: EventEmitter<unknown> = new EventEmitter();
  chartValueChanged: EventEmitter<any> = new EventEmitter();
  chartInitialized: EventEmitter<any> = new EventEmitter();

  /****** Socket variables ******/
  topic = '';  analyticsTopic = '';
  private stompClient = null;  private stompClientForAnalytics = null;

  /****** Filters ******/
  filter_HPF = false;  filter_LPF = false;  filter_notch = false;  filter_adaptive = false;
  adaptiveMatchText = 'Adaptive High';  HPFMatchText = 'High Pass Filter';
  LPFMatchText = 'Low Pass Filter';  NotchMatchText = 'Notch Filter';

  /****** Chart configuration ******/
  showgraph = true;  lastChannelValues = [];  lastAnalyticsEventsCount = 0;
  _chart = null;  chartRows = [];  prev_upLim = 100;  prev_lowLim = -100;  prev_maxSigValue;  prev_minSigValue;
  series = [];  analyticsEvents = [];
  subscriptions = {
    sensorData: null,
    analyticsEvents: null
  };
  lastDataTimestamp = moment().toDate().getTime(); // now
  isScheduledExecutorRunning = false;
  uiPreferences = {};
  timeOffset = 0; // milliseconds
  maxTimeOffset = 30; // seconds
  maxNoDataPeriod = 30; // seconds
  warnings = {
    noRecentData: false,
    offsetLimitExceeded: false,
    dataGapDetected: false
  };
  uniqueId: any;  drawMode = 'slide';  drawModes;  xdataRange;  gain: any;
  enabled;  selected;   pollingInterval;   timeRangePref;   chartType;  showValue;  numberFormat;  currentValueTpl;
  channels;  timeRange;  timeRanges;  processedTimeRanges;  speed;  speeds;  zoom;  scale;  scales;  processedScale;
  showAmplitude;  showAmplitudes;  fullscreen;  currentValues = 0;  ease;  animation;  activityStatus;
  private loadingSingleGraph = false;
  private historyStartDate = new FormControl(new Date());
  date = new FormControl(new Date());
    private maxTimeRange: number;
  /****** Constructor ******/
  constructor(private webSocketService: WebSocketService, private cookieService: CookieService,
              private chartOffsetCalculatorService: ChartOffsetCalculatorService,
              private sensorDataConverter: SensorDataConverter,
              protected userPreferences: UserPreferenceService,
              private securityService: EcareSecurityService,
              private sensorDataService: SensorDataService,
              private toastr: ToastrService) {
  }

  /****** onInit lifecycle ******/
  ngOnInit() {
    /****** To View - initialize all visual chart configuration ******/
    this.timeRanges = this.uiConfiguration.find(x => x.id === 'sensorData/chart/timeRange').properties;
    this.processedTimeRanges = this.uiConfiguration.find(x => x.id === 'sensorData/chart/' + this.dataStream.dataStreamType.category + '/timeRange');
    this.drawModes = this.uiConfiguration.find(x => x.id === 'sensorData/chart/' +
        this.dataStream.dataStreamType.category + '/type').properties;
    this.showAmplitudes = this.uiConfiguration.find(x => x.id === 'sensorData/chart/showAmplitude').properties;
    this.scales = this.uiConfiguration.find(x => x.id === 'sensorData/chart/scale').properties;
    this.processedScale = this.uiConfiguration.find(x => x.id === 'sensorData/chart/zoom').properties;
    this.speeds = this.uiConfiguration.find(x => x.id === 'sensorData/chart/speed').properties;
    /****** To Chart - all chart configuration ******/
    this.uniqueId = 'historychart' + this.divCounter;
    this.drawMode = this.settings.chart[this.dataStream.id].chartType.defaultValue;
    this.timeRange = this.settings.chart.timeRange;
    this.speed = this.settings.chart.speed;
    this.timeRange = this.speed * 60; // Added to fix onload issue
    this.zoom = this.settings.chart.zoom;
    this.scale = this.settings.chart.scale;
    this.xdataRange = this.settings.chart.timeRange;
    this.showAmplitude = this.settings.chart.showAmplitude;
    this.selected = this.settings.chart[this.dataStream.id].selected;
    this.enabled = this.dataStream.enabled;
    this.chartType = this.settings.chart[this.dataStream.id].chartType;
    this.showValue = this.settings.chart[this.dataStream.id].showValue;
    this.numberFormat = this.settings.chart[this.dataStream.id].numberFormat;
    this.currentValueTpl = this.settings.chart[this.dataStream.id].currentValueTpl;
    this.channels = this.settings.chart[this.dataStream.id].channelConfig;
    this.fullscreen = this.settings.chart[this.dataStream.id].fullscreen;
    if (this.enabled && this.selected) {
      this.topic = '/dataStream/' + this.dataStream.id;
      this.analyticsTopic = '/analytics/' + this.dataStream.id;
      this.loadData(Math.round(this.start / 1000));
      //  this.loadData(1570015920);
    }
    /*TODO- Set user time zone */
      if (this.start !== '') {
          this.date = new FormControl(this.start);
      }
  }

  /* Initialize chart */
  ngAfterViewInit() {
    if (this.enabled && this.selected){
      this.init();
    }
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges) {
    const currentItem: SimpleChange = changes.start;
    if (!currentItem.firstChange) {
        let start = Math.round(currentItem.currentValue / 1000);
        this.date = new FormControl(this.start);
        this.reloadGraph(start);
    }
  }
  /* On page leave, disconnect sockets*/
  ngOnDestroy() {
    //this.webSocketService.unsubscribe(this.subscriptions, this.topic);
  }

  init() {
    // setTimeout( () => {
    if (this._chart) {
      this._chart.destroy();
      this.chartRows.length = 0; // clear chart rows
      this._chart = null; // added
    }
    try{
      this._chart = new SensorChart(this.uniqueId);
    } catch(e){
      return;
    }
    if(this.dataStream.dataStreamType.id === 'SPO2_OXIGEN'){
      this._chart._numericAxis.scaleType = new FixedScale(0, 100);
    }
    this._chart.setStartTime(new Date(this.start).getTime());
      this._chart.options.background = '#222';
    this._chart.options.foreground = '#9d9d9d';
    this._chart.options.labelBackground = '#333';
    this._chart.options.labelForeground = '#9d9d9d';
    this._chart.options.grid.color = '#333';
    this._chart.options.timeline.color = '#444';
    this._chart.options.seriesColor = '#F00000';
    this._chart._timeline.scaleType = new FixedDisplayPeriodScale();
    this._chart.options.grid.display = 'none';
    /***** For ECG type *****/
    if ( this.dataStream && (this.dataStream.dataStreamType.category === 'ECG' || this.dataStream.dataStreamType.category === 'ECG_III'
      || this.dataStream.dataStreamType.category === 'ECG_aVR' || this.dataStream.dataStreamType.category === 'ECG_aVL'
      || this.dataStream.dataStreamType.category === 'ECG_aVF')) {
      // set scaling ratio and grid from sensor type configuration
      this.speed = this.speed || 100;
      const xLines = 6;
      const minorLines = 10;
      this.xdataRange = this.speed * xLines * minorLines;
      this._chart._timeline.setDisplayPeriod(this.xdataRange);
      this.prev_upLim = 100;
      this.prev_lowLim = -100;
      this.gain = this.scale || 1;
      const yLines = 21;
      const pyValue = 2.5 * RatioScale.PX_PER_CM;
      this._chart.options.grid.display = 'both';
      this._chart.options.grid.interval =  {
        x: {
          major: this.xdataRange / xLines, // 1 second
          minor: this.xdataRange / (xLines * minorLines)
        }
      },
        this. _chart.options.grid.intervalPX = {
          y: {
            major: pyValue,
            minor: pyValue / 10
          }
        };
      if (this.speed * xLines * minorLines >= 24 * 60 * 60 * 1000) {
        this._chart.options.format.timeFormat = 'DD-MM-YYYY HH:mm:ss';
      }
    } /***** For non ECG types *****/ else {
      const zoom = this.zoom || 1;
      this._chart._timeline.setDisplayPeriod(this.timeRange / zoom);
      if (this.timeRange / zoom >= 24 * 60 * 60 * 1000) {
        this._chart.options.format.timeFormat = 'DD-MM-YYYY HH:mm:ss';
      }
    }
    this._chart.offset = this.timeOffset;
    if (this.dataStream && this.dataStream.dataStreamType.id === 'TEMPERATURE' && this.uiUOM.TEMPERATURE) {
      this.dataStream.dataStreamType.uiConfig['unitOfMeasure'] = this.uiUOM.TEMPERATURE;
      this._chart.setUnitOfMeasure(this.uiUOM.TEMPERATURE);
    } else {
      this._chart.setUnitOfMeasure(this.dataStream && this.dataStream.dataStreamType.uiConfig['unitOfMeasure'] || '');
    }
    this._chart.setData(this.chartRows);
    this._chart.setSeries.apply(this._chart, this.series);
    this._chart.redraw();
    this.chartInitialized.emit( {
      displayPeriod: this._chart._timeline.getDisplayPeriod()
    });
    this.loadingSingleGraph = false;
  }

  subscribe() {
    this.stompClient = this.webSocketService.connect();
    const _this = this;
    _this.stompClient.connect('', '' , function (frame) {
      const __this = _this;
      const headers = {
        'Authorization': 'bearer ' + _this.cookieService.get('ecare_access_token'),
      }
      const subscription = _this.stompClient.subscribe(_this.topic, function (sensorData) {
          const parsedBody = JSON.parse(sensorData.body);
          _this.onDataArrived(parsedBody);
      }, headers);
      __this.subscriptions[subscription] = {'topic': _this.topic, 'unsubscribe': subscription.unsubscribe };
      return __this.subscriptions[subscription];
    });

    // Analytics - NOT IN USE YET
/*    this.webSocketService.sock_connected.subscribe(connected => {
      if (connected ) {
        _this.stompClientForAnalytics.connect({}, function (frame) {
          const __this = _this;
          const subscription = _this.stompClientForAnalytics.subscribe(_this.topic, function (analyticData) {
            // Dont do anything yet
          });
        });
      }
    });*/
  }

  loadData(start) {
    // temporary for testing
    this.start =  moment.unix(start).format('YYYY-MM-DD[T]HH:mm:ss');
    //this._chart.setStartTime(start.getTime());
    if (this.start === '') {
      const today = moment().toDate();  // This will return a copy of the Date that the moment uses
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      this.start = today.getTime();
    }
    if (!this.dataStream) {
      return;
    }
    const date = this.start;
    let from = moment(date).subtract(1, 'seconds');
    let to = moment(date).add((this.timeRange / (this.zoom || 1) + 1000) / 1000, 'seconds');
    if( this.dataStream && (this.dataStream.dataStreamType.category === 'ECG' || this.dataStream.dataStreamType.category === 'ECG_III'
        || this.dataStream.dataStreamType.category === 'ECG_aVR' || this.dataStream.dataStreamType.category === 'ECG_aVL'
        || this.dataStream.dataStreamType.category === 'ECG_aVF')) {
      from = moment(date).subtract(1, 'seconds');
      to = moment(date).add((this.timeRange + 1000) / 1000, 'seconds');
    } else {
      from = moment(date).subtract(1, 'seconds');
      to = moment(date).add((this.timeRange / (this.zoom || 1) + 1000) / 1000, 'seconds');
    }

     //this._chart.setStartTime(from);

    /*sensorDataService.getEvents(scope.dataStream.id, from, to)
        .then(function(events){
          if(!events){ return; }
          onEventsArrived(events);
        });*/

    this.sensorDataService.getSensorData(this.dataStream.id, from, to).subscribe(
        data =>{
          if(!data) {	return;	}
          for(let c = 0; c < data.length; c++) {
              this.onDataArrived(data[c]);
          }
          //isLoading = false;
          //this.loadData(data);
        }
    );
}

  onDataArrived(data) {
          this.lastDataTimestamp = moment().toDate().getTime();
          this.currentValues = data;
          if (this.dataStream.dataStreamType.category === 'ACTIVITY') {
              console.log(this.currentValues)
              if (this.currentValues === 0) {
                  this.activityStatus = 'Sitting/Standing';
              }
              if (this.currentValues === 1) {
                  this.activityStatus = 'Small Movement';
              }
              if (this.currentValues === 2) {
                  this.activityStatus = 'Large Movement';
              }
              if (this.currentValues === 3) {
                  this.activityStatus = 'Walking';
              }
              if (this.currentValues === 4) {
                  this.activityStatus = 'Running';
              }
              if (this.currentValues === 5) {
                  this.activityStatus = 'Lying on Back';
              }
              if (this.currentValues === 6) {
                  this.activityStatus = 'Lying face down';
              }
              if (this.currentValues === 7) {
                  this.activityStatus = 'Lying on Right Side';
              }
              if (this.currentValues === 8) {
                  this.activityStatus = 'Lying on Left Side';
              }
              if (this.currentValues === 9) {
                  this.activityStatus = 'Lying on an Angle';
              }
          }
         /* let oldOffset = this.timeOffset;
          this.timeOffset = -this.updateOffset(data); //compensate the offset
          if (this._chart) {
              if (this.ease) {
                  this.ease.cancel();
              }
              const _this = this;
              this.ease = animate(oldOffset, this.timeOffset, function (frame) {
                  _this._chart.offset = frame;
              }, EasingFunctions.easeOutQuad, 1500);
          }*/
          // Above addition
          if (!this._chart || !data) {
              return;
          }
          if (this.series.length === 0) {
              this.series = this.initSeries(data.channels);
              this._chart.setSeries.apply(this._chart, this.series);
          }

          const convertedRows = this.sensorDataConverter.convertData(data);
          for (let i = 0; i < convertedRows.length; i++) {
              this.chartRows.push(convertedRows[i]);
          }

          if (this.dataStream && (this.dataStream.dataStreamType.category === 'ECG' || this.dataStream.dataStreamType.category === 'ECG_III'
              || this.dataStream.dataStreamType.category === 'ECG_aVR' || this.dataStream.dataStreamType.category === 'ECG_aVL'
              || this.dataStream.dataStreamType.category === 'ECG_aVF')) {
              const gain: any = parseFloat(this.scale).toFixed(3) || 1;
              // const gain: any = 0.1;
              const speed: any = this.speed || 100;
              let lowLim = (-1) * gain * 10;
              let upLim = gain * 10;
              if (this.chartRows.length > 0) {
                  let min_Signalval = 100000;
                  let max_Signalval = -100000;
                  for (let i = 0; i < this.chartRows.length; i++) {
                      if (this.chartRows[i][1] < min_Signalval) {
                          min_Signalval = this.chartRows[i][1];
                      } else if (this.chartRows[i][1] > max_Signalval) {
                          max_Signalval = this.chartRows[i][1];
                      }
                  }
                  const totalDefDisplacement = Math.abs(upLim) + Math.abs(lowLim);
                  let newDisplacement = 0.0;
                  let newCenter = 0.0;
                  let newUplimit = upLim;
                  let newLowLimit = lowLim;

                  if (min_Signalval >= 0 && max_Signalval >= 0) {
                      newCenter = (Math.abs(max_Signalval) + Math.abs(min_Signalval)) / 2;
                      newDisplacement = Math.abs(max_Signalval) - Math.abs(min_Signalval);

                  } else if (min_Signalval < 0 && max_Signalval >= 0) {
                      newCenter = (Math.abs(max_Signalval) + Math.abs(min_Signalval)) / 2 + min_Signalval;
                      newDisplacement = Math.abs(max_Signalval) + Math.abs(min_Signalval);

                  } else if (min_Signalval < 0 && max_Signalval < 0) {
                      newCenter = (min_Signalval - max_Signalval) / 2 + max_Signalval;
                      newDisplacement = (Math.abs(min_Signalval) - Math.abs(max_Signalval));
                  }
                  newCenter = newCenter - (newCenter % gain);
                  newUplimit = newCenter + (gain * 10);
                  newLowLimit = newCenter - (gain * 10);
                  upLim = Number(parseFloat(String(newUplimit)).toFixed(3));
                  lowLim = Number(parseFloat(String(newLowLimit)).toFixed(3));
                  if (this.prev_upLim === 100 || this.prev_lowLim === -100 || upLim !== this.prev_upLim || lowLim !== this.prev_lowLim) {
                      this._chart._numericAxis.scaleType = new FixedScale(Number(lowLim), Number(upLim));
                      this.prev_upLim = Number(upLim);
                      this.prev_lowLim = Number(lowLim);
                  }
                  const chartAmplitudeValue = {
                      newValue: max_Signalval - min_Signalval,
                      dataStream: this.dataStream
                  };
                  this.chartAmplitudeValueChanged.emit(chartAmplitudeValue);
              }
              this.filter_HPF = false;
              this.filter_LPF = false;
              this.filter_notch = false;
              this.filter_adaptive = false;

              for (const filter of data.filtersApplied) {
                  if (filter.startsWith(this.HPFMatchText)) {
                      this.filter_HPF = true;
                  } else if (filter.startsWith(this.LPFMatchText)) {
                      this.filter_LPF = true;
                  } else if (filter.startsWith(this.NotchMatchText)) {
                      this.filter_notch = true;
                  } else if (filter.startsWith(this.adaptiveMatchText)) {
                      this.filter_adaptive = true;
                  }
              }
              this.sensorDataConverter.sort(this.chartRows);
              // this.shortenData(this.chartRows);
              // this.emitCurrentValue(data);
              this.redraw();
          }
  }

    redraw() {
        if (/*$(elements[0]).is(":visible") && */this._chart) {
            this._chart.setSeries.apply(this._chart, this.series);
//							_chart.setData(chartRows);
            // TODO - analytics event to be implemented later
            /*if (this.dataStream.dataStreamType.id === 'ECG_I' ||
                this.dataStream.dataStreamType.id === 'ECG_II') {
               let markers = _.map(analyticsEvents, function(event){
                    return {timestamp: event.timestamp, color: "#ffeecc", type: visualization.dataset.MarkerType.HIGHLIGHT, value: 1000};
                });
            } else {
                let markers = _.map(analyticsEvents, function(event){
                    return {timestamp: event.timestamp, color: "red"};
                });
            }
            _chart.setMarkers(markers);*/
            this._chart.redraw();
        }
    }

  shortenData(data) {
    if(!data || !this._chart) {
      return [];
    }
    let now = new Date();
    let start = now.getTime() + this.timeOffset - this._chart._timeline.getDisplayPeriod();
    while (data.length > 0) {
      if (data[0][0] < start) {
        data.shift();
      } else {
        break;
      }
    }
  }

  updateOffset(data) {
    if (!data || !this._chart) {
      return;
    }
    return this.chartOffsetCalculatorService.computeOffset(this.dataStream.id, data.timestamp);
  }

  emitCurrentValue(data) {
    if (!data) {
      // fire an event with value=undefined only once when there is no data
      if (this.lastChannelValues.length > 0 && this.chartRows.length === 0) {
        const value = {
          newValue: undefined,
          dataStream: this.dataStream
        };
        this.chartValueChanged.emit({'offset-changed-event': value});
        this.lastChannelValues = [];
      }
      return;
    }
    const channels = data.channels;
    const currentChannelValues = [];
    let valuesChanged = false;
    for (let i = 0; i < channels; i++) {
      const chartItem = (this.chartRows.length > 0) ?  this.chartRows[this.chartRows.length - 1] : Array(channels + 1).fill(0);
      currentChannelValues[i] = chartItem[i + 1];
      if (this.lastChannelValues[i] !== currentChannelValues[i]) {
        valuesChanged = true;
      }
    }
    if (this.dataStream.dataStreamType.id === 'GEN_STEP_COUNT') {
      let sum = 0;
      for (const row of this.chartRows) {
        sum += row[1] || 0;
      }
      this.chartValueChanged.emit({'offset-changed-event': {
          newValue: [sum],
          dataStream: this.dataStream
        }});
      this.lastChannelValues = currentChannelValues;
    } else if (valuesChanged) {
      this.chartValueChanged.emit({'offset-changed-event': {
          newValue: currentChannelValues,
          dataStream: this.dataStream,
          timestamp: data.timestamp
        }});
      this.lastChannelValues = currentChannelValues;
    }
  }

  initSeries(channels) {
    const colors = ['#36C', '#DC3912', '#FF9900', '#109618',
      '#990099', '#0099C6', '#1B9E77'];
    const channelPrefs = this.uiPreferences['sensorData/'
    + this.dataStream.dataStreamType.category
    + '/channels'];

    const series = [];
    for (let i = 0; i < channels; i++) {
      const channelName = channelPrefs ? channelPrefs.defaultValue[i].name : 'CH-' + (i + 1);
      const color = channelPrefs ? channelPrefs.defaultValue[i].color || colors[i] : colors[i];
      series[i] = new TimeSeries(channelName, color);
      series[i].values = this.chartRows;
      const index = i + 1;
      // tslint:disable-next-line:no-shadowed-variable
      series[i].valueProvider.getY = (function( index ) {
        return function(item) {
          return (item) ? item[index] : undefined;
        };
      })(index);
    }
    return series;
  }

  /*initTimezone() {
    if (this.currentUser) {
      moment.tz(this.loginUser.timeZone || 'UTC');
    }
  };*/

  updateTimeRange(updateTimeRange) {
    this.timeRange = updateTimeRange;
    const prefs = {};
    this.reloadGraph(this.start);
    prefs['sensorData/chart/' + this.dataStream.id + '/timeRange'] = updateTimeRange;
    this.updateUserPreference(prefs);
  }

  updateDrawMode(drawMode) {
    const prefs = {};
    this.drawMode = drawMode;
    this.init();
    prefs['sensorData/chart/' + this.dataStream.id + '/type'] = drawMode;
    this.updateUserPreference(prefs);
  }

  updateShowAmplitude(showAmplitude) {
    this.showAmplitude = showAmplitude;
    const prefs = {};
    prefs['sensorData/chart/showAmplitude'] = showAmplitude;
    this.updateUserPreference(prefs);
  }

  updateScale(scale) {
    this.scale = scale.value;
    const prefs = {};
      this.reloadGraph(this.start);
      prefs['sensorData/chart/scale'] = scale.value;
    this.updateUserPreference(prefs);
  }

  updateSpeed(speed) {
    this.speed = speed;
    this.timeRange = speed * 60;
    this.reloadGraph(this.start);
    const prefs = {};
    prefs['sensorData/chart/speed'] = speed;
    this.updateUserPreference(prefs);
  }

  updateZoom(zoom) {
    this.scale = zoom;
    const prefs = {};
    prefs['sensorData/chart/zoom'] = zoom;
    this.updateUserPreference(prefs);
  }

  showFullScreen(fullscreen) {
    this.fullscreen = fullscreen;
  }

  updateUserPreference(prefs) {
    this.userPreferences.update(prefs, this.securityService.getUserDetails()).subscribe(
        response => {
          this.toastr.success('Preferences has been updated!', 'Successful!');
        });
    this.reloadGraph(this.start);
  }

  exitFullScreen() {
    this.settings.chart[this.dataStream.id].fullscreen = false;
    this.fullscreen = false;
  }

  doCheckLastPacket(){
    setTimeout(() => {
      if(moment().toDate().getTime() - this.lastDataTimestamp > this.maxNoDataPeriod * 1000) {
        this.warnings.noRecentData = true;
      } else {
        this.warnings.noRecentData = false;
      }
      this.doCheckLastPacket();
    }, 10000);
  }

    changeTime(time) {
        // @ts-ignore
        time =  Math.floor(time / 1000);
        this.date = new FormControl(moment(this.date.value).add(time, 'seconds').toDate());
        this.setHistoryStartDate(this.date);
        this.start = moment(this.date.value).add(time, 'seconds').unix();
        this.reloadGraph(this.start);

        //this.start =  moment.unix(start).format('YYYY-MM-DD[T]HH:mm:ss');
    }

    setHistoryStartDate(date) {
        date.value.setMilliseconds(0);

        if (this.historyStartDate.value
            && this.historyStartDate.value.getTime() === date.value.getTime()) {
            return;
        }

        this.historyStartDate = date;
        // this.onDateChanged();
    }

    calculateMaxTimeRange() {
        let maxDisplayPeriod = 1000;
        maxDisplayPeriod = Math.max(maxDisplayPeriod, this.timeRange);
        this.maxTimeRange = maxDisplayPeriod;
    }

    reloadGraph(start) {
        this.loadData(start);
        this.init();
        //this.timeRange = start;
        // this._chart.setStartTime(new Date(start).getTime()); // Temporary to fix graph start time
    }

}
